export default {
  state: {
    modalInfo: {
      isVisible: false,
      text: '',
      icon: '',
      buttons: [],
      types: {
        default: {
          icon: 'check',
          buttons: [
            {
              buttonText: 'Fechar',
              buttonAction: 'closeModal'
            }
          ]
        },
        success: {
          icon: 'check',
          buttons: [
            {
              buttonText: 'Fechar',
              buttonAction: 'closeModal'
            }
          ]
        },
        defaultDialog: {
          icon: 'question',
          buttons: [
            {
              buttonText: 'Sim',
              buttonAction: 'actionTrue'
            },
            {
              buttonText: 'Não',
              buttonAction: 'actionFalse'
            }
          ]
        },
        error: {
          icon: 'warning',
          buttons: [
            {
              buttonText: 'Fechar',
              buttonAction: ''
            }
          ]
        }
      }
    },
    deleteItemMenu: {
      isVisible: false
    }
  },
  getters: {
    modalInfo: (state) => state.modalInfo,
    deleteItemMenu: (state) => state.deleteItemMenu
  },
  mutations: {
    showModalInfo (state, data) {
      const type = data.type || 'default'
      state.modalInfo.text = data.text
      state.modalInfo.icon = data.icon || state.modalInfo.types[type].icon
      state.modalInfo.buttons = data.buttons || state.modalInfo.types[type].buttons

      if (data.open) {
        state.modalInfo.isVisible = true
      }
    },
    closeModalInfo (state) {
      state.modalInfo.isVisible = false
    },
    setDeleteItemMenuVisibility (state) {
      state.deleteItemMenu.isVisible = !state.deleteItemMenu.isVisible
    }
  },
  actions: {
    showModalInfo ({ commit }, data) {
      commit('showModalInfo', data)
    },
    closeModalInfo ({ commit }) {
      commit('closeModalInfo')
    },
    changeDeleteItemVisibility ({ commit }) {
      commit('setDeleteItemMenuVisibility')
    }
  }
}
